import {
    FlightRequestHistoryListState,
    GET_FLIGHT_REQUEST_HISTORY_CLEAR,
    GET_FLIGHT_REQUEST_HISTORY_SUCCESS,
    GetFlightRequestHistoryActionTypes,
} from './types';

const flightHistoriesInitialState: FlightRequestHistoryListState = {
    data: [],
    total: 0,
};
export function getFlightRequestHistories(
    state = flightHistoriesInitialState,
    action: GetFlightRequestHistoryActionTypes,
) {
    switch (action.type) {
        case GET_FLIGHT_REQUEST_HISTORY_CLEAR:
            return action.payload;
        case GET_FLIGHT_REQUEST_HISTORY_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
